import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CorporateClient } from '../../common/interfaces/corporate-client.interface';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../../common/services/base.service';

@Injectable()
export class CorporateClientService extends BaseService {
    constructor(private httpClient: HttpClient) {
        super();
    }

    findAll(withRoles: boolean = false): Observable<CorporateClient[]> {
        let params = new HttpParams();

        if (withRoles) {
            params = params.append('withRoles', withRoles);
        }
        return this.httpClient.get<CorporateClient[]>(this.getApiUrl() + '/corporate-clients', {params})
            .pipe(map((res: any) => res || []), catchError(() => []));
    }
}
